// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading--Mi2u66PA{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}.title--t7OpwWbH{font-size:12px;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;--shine-text-color:rgba(38,38,38,0.65);--shine-text-highlight-color:#dcdcdc}ai-portal\\.cruise-canvas .title--t7OpwWbH{text-indent:4px}ai-portal\\.cruise-canvas .heading--Mi2u66PA{margin-bottom:10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `heading--Mi2u66PA`,
	"title": `title--t7OpwWbH`
};
export default ___CSS_LOADER_EXPORT___;
